import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ea1a3ca&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1ea1a3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1a3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea1a3ca')) {
      api.createRecord('1ea1a3ca', component.options)
    } else {
      api.reload('1ea1a3ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1ea1a3ca&scoped=true&", function () {
      api.rerender('1ea1a3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goodsDrawer/index.vue"
export default component.exports